import { toast } from "sonner";
import { AccessToken } from "../enums/access-token";
import { PublicRoutes } from "../types/Routes";
import { GraphQLErrorResponse } from "../types/graphql-error";

const timer = 2000;

function isValidJSON(str: string) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export const errorParser = (err: unknown): string => {
  const errorMessage = (err as { message: string }).message;

  console.log(err, "++++++++++");

  // Extract the JSON part of the error message
  const jsonStartIndex = errorMessage.indexOf("{");
  const jsonPart = errorMessage.substring(jsonStartIndex);

  if (jsonPart === "TypeError: Failed to fetch") {
    return "An error occurred, please check your network!";
  }

  const isValid = isValidJSON(jsonPart);

  let parsedErrorRes;
  let parsedErrorStr;

  if (!isValid) {
    parsedErrorStr = jsonPart;
  } else {
    parsedErrorRes = JSON.parse(jsonPart) as GraphQLErrorResponse;
  }

  console.log(
    parsedErrorRes?.response?.errors?.[0]?.message ??
      parsedErrorStr ??
      "Something went wrong!"
  );
  const errMsg =
    parsedErrorRes?.response?.errors?.[0]?.message ??
    parsedErrorStr ??
    "Something went wrong!";

  if (errMsg === "Unauthorized") {
    setTimeout(() => {
      localStorage.removeItem(AccessToken.KEY);
      window.location.href = PublicRoutes.SIGNIN;
    }, timer);
  }

  return errMsg || errorMessage;
};
